import { Box } from '@mui/material';
import Link from "next/link";
import { useRouter } from 'next/router';

const LOGO_HOVER_SX = {
  cursor: 'pointer',
  transition: 'transform 0.15s ease, opacity 0.15s ease',
  '&:hover': {
    transform: 'scale(1.07)',
    opacity: 0.9,
  },
};

export default function Logo({ color, isPopup, height, width }) {
  const router = useRouter();
  const isDocsApi = router.pathname?.includes("/docs/api");
  const logoSrc = color === 'dark' ? "/assets/svg/logo_dark.svg" : "/assets/svg/logo.svg";

  return (
    <>
      <Link prefetch={false} href="/" aria-label="Grufity — go to homepage">
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            alignItems: 'flex-end',
            gap: 0.5,
            marginRight: isPopup ? 1 : (isDocsApi ? 0 : 4),
            ...LOGO_HOVER_SX,
          }}
        >
          <Box
            component="img"
            sx={{ height: height ?? 20, width: width ?? 70, display: 'block' }}
            alt="Grufity logo"
            src={logoSrc}
          />
          {isDocsApi && (
            <svg
              height="10"
              viewBox="0 0 260 113"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginBottom: '1px', display: 'block' }}
              aria-hidden="true"
            >
              <path
                d="M42.056 0.991992L0.248 113H23.024L31.916 88.976H78.092L86.984 113H110.228L68.264 0.991992H42.056ZM54.848 26.42L70.76 69.476H39.092L54.848 26.42ZM150.43 71.816H173.362C199.102 71.816 215.17 59.492 215.17 36.404C215.17 13.16 199.102 0.991992 173.362 0.991992H127.498V113H150.43V71.816ZM150.43 52.316V20.492H172.114C185.53 20.492 192.394 26.264 192.394 36.404C192.394 46.388 185.53 52.316 172.114 52.316H150.43ZM259.423 0.991992H236.491V113H259.423V0.991992Z"
                fill="#66b2ff"
              />
            </svg>
          )}
        </Box>
      </Link>
      <Link prefetch={false} href="/" aria-label="Grufity — go to homepage">
        <Box
          component="img"
          sx={{
            height: 20,
            width: 70,
            display: { xs: "flex", md: "none" },
            ...LOGO_HOVER_SX,
          }}
          alt="Grufity logo"
          src={logoSrc}
        />
      </Link>
    </>
  );
}